var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"data-theme":_vm.themeVariant}},[_c('AppBar'),_c('v-main',{staticClass:"main-container"},[_c('CodeMatrixBackground'),_c('NeuralWaveBackground'),_c('AppLoader'),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }